import React, { useState, useRef } from "react";
import { Toast } from "primereact/toast";

import { getDatabase, ref, child, push, set } from "firebase/database";
import {
  intrductoryData,
  menuData,
  messageToClient,
  NOTIFICATION_TYPES,
} from "../const/profileConstants";
import BaseSectionItem from "./BaseSectionItem";
import { faEnvelope, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faStackOverflow } from "@fortawesome/free-brands-svg-icons";
import { getCurrentTime, openlink, showNotification } from "../utility";
import message_bg from "../message_bg.png";

export const ContactItem = () => {
  const [message, setMessage] = useState("");
  const [showContactTooltip, setShowContactTooltip] = useState(false);
  const toastRef = useRef(null);

  const sendMessage = (msg) => {
    const db = getDatabase();
    var reference = push(child(ref(db), "message")).key;

    const [currentFormattedTime, currentDisplayTime] = getCurrentTime();

    set(ref(db, "message/" + reference), {
      message: msg,
      formatted_time: currentFormattedTime,
      display_time: currentDisplayTime,
    })
      .then(() => {
        showNotification({
          toastRef,
          message: "Message Received Successfully!",
          type: NOTIFICATION_TYPES.SUCCESS,
        });
        setMessage("");
      })
      .catch((error) => {
        showNotification({
          toastRef,
          message: error,
          type: NOTIFICATION_TYPES.ERROR,
        });
      });
  };

  const copyEmail = (email) => {
    navigator.clipboard.writeText(email);
    showNotification({
      toastRef,
      message:
        "My email address copied to your clipboard. Paste it anywhere you need.",
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  };

  const renderImage = () => (
    <div className="me-chat-container">
      <img src={intrductoryData.image} alt={intrductoryData.name} />
    </div>
  );

  return (
    <BaseSectionItem
      header={menuData[6].value}
      renderImage={renderImage}
      onMouseEnter={() => {
        setShowContactTooltip(true);
      }}
      onMouseLeave={() => {
        setShowContactTooltip(false);
      }}
    >
      {showContactTooltip && (
        <div className="msg-container">
          <div id="message" className="message">
            <div>{messageToClient}</div>
            <img src={message_bg} alt="My message" />
          </div>
        </div>
      )}
      <div className="d-flex flex-row">
        <FontAwesomeIcon icon={faEnvelope} className="contact-email-icon" />
        <div className="contact-email-list">
          <div
            className="email"
            data-email={intrductoryData.email1}
            onClick={(e) => {
              copyEmail(e.target.getAttribute("data-email"));
            }}
          >
            {intrductoryData.email1}
          </div>
          <div
            className="email"
            data-email={intrductoryData.email2}
            onClick={(e) => {
              copyEmail(e.target.getAttribute("data-email"));
            }}
          >
            {intrductoryData.email2}
          </div>
        </div>
      </div>

      <div className="p-rel inp-msg-container">
        <textarea
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          value={message}
          className="inpput-message"
          type="text"
          placeholder="What do you want to say to me?"
        ></textarea>
        <div id="send" class={`send ${message ? "" : "disabled"}`}>
          <FontAwesomeIcon
            icon={faPaperPlane}
            onClick={() => {
              sendMessage(message);
            }}
          />
        </div>
      </div>

      <div className="w-100 d-flex align-items-center justify-content-center">
        <div className="d-flex flex-row mt-2">
          <div
            className="contact-icon"
            onClick={(e) => {
              openlink("https://github.com/apurbok");
            }}
          >
            <FontAwesomeIcon icon={faGithub} />
          </div>
          <div
            className="contact-icon"
            onClick={() => {
              openlink("https://stackoverflow.com/users/12813569/dragooon");
            }}
          >
            <FontAwesomeIcon icon={faStackOverflow} />
          </div>
        </div>
      </div>
      <div className="justify-content-right">Ⓒ Apurba Karmaker</div>
      <Toast ref={toastRef} />
    </BaseSectionItem>
  );
};

export default ContactItem;
